module.exports = __webpack_public_path__ + "static/deep-sea-blue--large-411b1782df9457ef4b893e4d5dd3f693.jpg";